/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFBrandFinderDetails
 */
export interface CRSFBrandFinderDetails {
    /**
     * 
     * @type {string}
     * @memberof CRSFBrandFinderDetails
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFBrandFinderDetails
     */
    explanation?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFBrandFinderDetails
     */
    reason: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFBrandFinderDetails
     */
    sources?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFBrandFinderDetails
     */
    target: string;
}

/**
 * Check if a given object implements the CRSFBrandFinderDetails interface.
 */
export function instanceOfCRSFBrandFinderDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "target" in value;

    return isInstance;
}

export function CRSFBrandFinderDetailsFromJSON(json: any): CRSFBrandFinderDetails {
    return CRSFBrandFinderDetailsFromJSONTyped(json, false);
}

export function CRSFBrandFinderDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFBrandFinderDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'domain': json['domain'],
        'explanation': !exists(json, 'explanation') ? undefined : json['explanation'],
        'reason': json['reason'],
        'sources': !exists(json, 'sources') ? undefined : json['sources'],
        'target': json['target'],
    };
}

export function CRSFBrandFinderDetailsToJSON(value?: CRSFBrandFinderDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'domain': value.domain,
        'explanation': value.explanation,
        'reason': value.reason,
        'sources': value.sources,
        'target': value.target,
    };
}

